import Ajax from "Utils/ajax";
export const getDesignationList = (data) => Ajax.post('admin/getDesignationList',data);
export const addUpdateDesignation = (data) => Ajax.post('admin/addUpdateDesignation',data);
export const deleteDesignation = (data) => Ajax.post('admin/deleteDesignation',data);